import UsersRequests from '../../server/users';
import { addLoading, removeLoading } from './loading';

export const setUsers = users => ({
  type: 'GET_USERS',
  users,
});

export const setUsersPermissionsDeleteApprovers = usersPermissionsDeleteApprovers => ({
  type: 'GET_USERS_PERMISSIONS_DELETE_APPROVERS',
  usersPermissionsDeleteApprovers,
});

export const setContractsFilter = contracts => ({
  type: 'GET_USERS_CONTRACTS_FILTER',
  contracts,
});

export const getUsers = (
  limit, skip, clientId, search = '', type = '', status = '', order = '', field = '',
) => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    const users = await UsersRequests.getUsers(limit, skip, clientId, search, type, status, order, field);
    dispatch(setUsers(users));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};
export const getAllUsers = (
  limit, skip, search = '', type = '', status = '', order = '', field = '',
) => async (dispatch) => {
  if (!search) dispatch(addLoading());
  try {
    const users = await UsersRequests.getAllUsers(limit, skip, search, type, status, order, field);
    dispatch(setUsers(users));
  } finally {
    if (!search) dispatch(removeLoading());
  }
};

export const activeUser = (id, status) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await UsersRequests.activeUser(id, status);
  } finally {
    dispatch(removeLoading());
  }
};

export const multiApprove = (id, multi) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await UsersRequests.multiApprove(id, multi);
  } finally {
    dispatch(removeLoading());
  }
};

export const resendPassword = userId => async (dispatch) => {
  dispatch(addLoading());
  try {
    await UsersRequests.resendPassword(userId);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateUserClientStatus = (clientId, userId, status) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await UsersRequests.updateUserClientStatus(clientId, userId, status);
  } finally {
    dispatch(removeLoading());
  }
};

export const updateUsersPermission = (
  clientId, userId, data, approveId1, approveId2, locationId, bu, deposit, deliveryCode, clientWithdraw, emailSeller,
) => async (dispatch) => {
  dispatch(addLoading());
  try {
    let err = false;
    await UsersRequests.updateUsersPermission(
      clientId, userId, data, approveId1, approveId2, locationId, bu, deposit, deliveryCode, clientWithdraw,
      emailSeller,
    ).catch((error) => {
      if (error.response) {
        dispatch(setUsersPermissionsDeleteApprovers(error.response.data.error.details));
        err = true;
      } else if (error.request) {
        dispatch(setUsersPermissionsDeleteApprovers(error.request));
        err = true;
      } else {
        dispatch(setUsersPermissionsDeleteApprovers(error.message));
        err = true;
      }
    });
    if (!err) dispatch(setUsersPermissionsDeleteApprovers(''));
  } finally {
    dispatch(removeLoading());
  }
};

export const createUser = user => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UsersRequests.createUser(user);
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadUsers = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await UsersRequests.uploadCsvUsers(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvUsersModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await UsersRequests.getCsvUsersModel();
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvUsersReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await UsersRequests.getCsvUsersReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const getAccessLoginReport = data => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UsersRequests.getAccessLoginReport(data);
  } finally {
    dispatch(removeLoading());
  }
};

export const getParamsNewUser = (clientId, state) => async (dispatch) => {
  dispatch(addLoading());
  try {
    return await UsersRequests.getParamsNewUser(clientId, state);
  } finally {
    dispatch(removeLoading());
  }
};
